import { defineMessage } from 'services/localization';

export const messages = {
    rejectButtonTitle: defineMessage('reject_the_request_and_make_a_comment'),
    approveButtonTitle: defineMessage('approve_the_request'),
    submitButtonTitle: defineMessage('submit_request_for_appr_rovers_will_be_notified'),
    openAuditReportButtonText: defineMessage('open_audit_report'),
    rejectButtonText: defineMessage('reject'),
    approveButtonText: defineMessage('approve'),
    submitButtonText: defineMessage('submit_for_approval'),
    add: defineMessage('add'),
    watchersButtonTitle: defineMessage('change_watchers_in_this_request'),
    watchersButtonTitleReadOnly: defineMessage('view_watchers_in_this_request'),
    retryButtonTitle: defineMessage('resend_to_netsuite'),
    retryButtonText: defineMessage('resend'),
    versionHistoryButtonTitle: defineMessage('version_history'),
    forceSubmitForApprovalButtonText: defineMessage('force_submit_for_approval'),
    forceSubmitForApprovalButtonTitle: defineMessage('submit_request_for_appr_rovers_will_be_notified'),
    editButtonText: defineMessage('edit'),
    editButtonTitle: defineMessage('edit_the_request'),
    submitForApprovalButtonText: defineMessage('submit_for_approval'),
    submitForApprovalButtonTitle: defineMessage('submit_request_for_appr_rovers_will_be_notified'),
    sendToReview: defineMessage('send_to_review'),
};
